/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: cBid28PspI_h
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AppShell from "../../AppShell"; // plasmic-import: Apa7akI9fuQs/component
import TabLayout from "../../TabLayout"; // plasmic-import: 0i0g7bSenwRJ/component
import Sidenav from "../../Sidenav"; // plasmic-import: gQC3DIuIxMM-/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import ButtonTab from "../../ButtonTab"; // plasmic-import: Z8Sy7rP6ZFXR/component
import PageLayout from "../../PageLayout"; // plasmic-import: 6gaQHJJIqual/component
import Topnav from "../../Topnav"; // plasmic-import: 0fErs5Rt_giR/component
import LeftSectionNav from "../../LeftSectionNav"; // plasmic-import: LqMwNzsXjkO-/component
import SeparatorHorizontal from "../../SeparatorHorizontal"; // plasmic-import: vjwl8iKCk0Vg/component
import PageInfoContainer from "../../PageInfoContainer"; // plasmic-import: n2Wtjyx7XW44/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicWebCompass.module.css"; // plasmic-import: cBid28PspI_h/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: H2aWiH48hSbz/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: ErJNYa-REKSk/icon
import image2RcDhf2RmVmG from "./images/image2.svg"; // plasmic-import: RcDhf_2RMVmG/picture
import image183TIq2GJx3VUp from "./images/image18.svg"; // plasmic-import: 3tIq2GJx3vUP/picture

createPlasmicElementProxy;

export const PlasmicWebCompass__VariantProps = new Array();

export const PlasmicWebCompass__ArgProps = new Array();

const $$ = {};

function PlasmicWebCompass__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"pageCompass"}
        data-plasmic-override={overrides.pageCompass}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.pageCompass
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <TabLayout
              data-plasmic-name={"tabLayout"}
              data-plasmic-override={overrides.tabLayout}
              className={classNames("__wab_instance", sty.tabLayout)}
              layoutType={"horizontalStacked"}
              tabContent={
                <PageLayout
                  data-plasmic-name={"pageLayout"}
                  data-plasmic-override={overrides.pageLayout}
                  className={classNames("__wab_instance", sty.pageLayout)}
                  layoutSections={"withNav"}
                  pageContent={
                    <PageInfoContainer
                      data-plasmic-name={"pageInfoContainer"}
                      data-plasmic-override={overrides.pageInfoContainer}
                      className={classNames(
                        "__wab_instance",
                        sty.pageInfoContainer
                      )}
                      containerType={"simplified"}
                      showHelperText={false}
                      stepHeader={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__exVu1
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ color: "var(--token-QpWActy9_SoE)" }}
                            >
                              {"OP compass."}
                            </span>
                            <React.Fragment>{" coming up..."}</React.Fragment>
                          </React.Fragment>
                        </div>
                      }
                      text={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__iMn0Q
                            )}
                          >
                            {"coming up..."}
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__fC8Gz
                            )}
                          >
                            {
                              "Communication, support, and resource module.\nConnect with teams, experts, peers... in the place you work."
                            }
                          </div>
                        </React.Fragment>
                      }
                      text4={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__qxE4W
                          )}
                        >
                          {
                            "Your hub for communication, connection, and resources.\nChat with peers, form groups, share knowledge, and find support, right where you work."
                          }
                        </div>
                      }
                    />
                  }
                  pageNav={
                    <React.Fragment>
                      <Topnav
                        data-plasmic-name={"topnav"}
                        data-plasmic-override={overrides.topnav}
                        className={classNames("__wab_instance", sty.topnav)}
                        layoutType={"justTitle"}
                        pageButtons={null}
                        pageTitle={
                          <LeftSectionNav
                            data-plasmic-name={"leftSectionNav"}
                            data-plasmic-override={overrides.leftSectionNav}
                            className={classNames(
                              "__wab_instance",
                              sty.leftSectionNav
                            )}
                            topNav={"tabTitle"}
                          >
                            {"compass."}
                          </LeftSectionNav>
                        }
                      />

                      <SeparatorHorizontal
                        data-plasmic-name={"separatorHorizontal"}
                        data-plasmic-override={overrides.separatorHorizontal}
                        className={classNames(
                          "__wab_instance",
                          sty.separatorHorizontal
                        )}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <Sidenav
                  data-plasmic-name={"sidenav"}
                  data-plasmic-override={overrides.sidenav}
                  backButton={
                    <ModuleNav
                      className={classNames(
                        "__wab_instance",
                        sty.moduleNav__shRr1
                      )}
                      navButtonSlot={
                        <ButtonNav
                          className={classNames(
                            "__wab_instance",
                            sty.buttonNav__utTbW
                          )}
                          color={"greyTwo"}
                          iconForButton={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__uyhL)}
                              displayHeight={"100%"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"none"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"100%"}
                              loading={"lazy"}
                              src={{
                                src: image183TIq2GJx3VUp,
                                fullWidth: 20,
                                fullHeight: 20,
                                aspectRatio: undefined
                              }}
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToWebHome"] = true
                              ? (() => {
                                  const actionArgs = { destination: `/home` };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToWebHome"] != null &&
                              typeof $steps["goToWebHome"] === "object" &&
                              typeof $steps["goToWebHome"].then === "function"
                            ) {
                              $steps["goToWebHome"] =
                                await $steps["goToWebHome"];
                            }
                          }}
                          shape={"globalRounding"}
                          status={"normal"}
                        />
                      }
                    />
                  }
                  className={classNames("__wab_instance", sty.sidenav)}
                  layoutType={"_default"}
                  logo={
                    <ModuleNav
                      className={classNames(
                        "__wab_instance",
                        sty.moduleNav__i8QMk
                      )}
                      navButtonSlot={
                        <ButtonNav
                          className={classNames(
                            "__wab_instance",
                            sty.buttonNav__zLfc6
                          )}
                          color={"white"}
                          iconForButton={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__dJzCt)}
                              displayHeight={"100%"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"none"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"100%"}
                              loading={"lazy"}
                              src={{
                                src: image2RcDhf2RmVmG,
                                fullWidth: 256,
                                fullHeight: 256,
                                aspectRatio: 1
                              }}
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToHttpsOpformypracticeCom"] = true
                              ? (() => {
                                  const actionArgs = {
                                    destination: "https://opformypractice.com/"
                                  };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToHttpsOpformypracticeCom"] != null &&
                              typeof $steps["goToHttpsOpformypracticeCom"] ===
                                "object" &&
                              typeof $steps["goToHttpsOpformypracticeCom"]
                                .then === "function"
                            ) {
                              $steps["goToHttpsOpformypracticeCom"] =
                                await $steps["goToHttpsOpformypracticeCom"];
                            }
                          }}
                          shape={"fullRounding"}
                          slotSize={"fillButton"}
                          status={"normal"}
                        />
                      }
                    />
                  }
                  tabs={
                    <React.Fragment>
                      <ButtonTab
                        className={classNames(
                          "__wab_instance",
                          sty.buttonTab__rvSTl
                        )}
                        iconTab={
                          <Icon12Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__lx2Dc
                            )}
                            role={"img"}
                          />
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebCompass"] = true
                            ? (() => {
                                const actionArgs = { destination: `/compass` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebCompass"] != null &&
                            typeof $steps["goToWebCompass"] === "object" &&
                            typeof $steps["goToWebCompass"].then === "function"
                          ) {
                            $steps["goToWebCompass"] =
                              await $steps["goToWebCompass"];
                          }
                        }}
                        type={"withLine"}
                      />

                      <ButtonTab
                        className={classNames(
                          "__wab_instance",
                          sty.buttonTab__zz4Wt
                        )}
                        iconTab={
                          <Icon4Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__wllTg
                            )}
                            role={"img"}
                          />
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSupport"] != null &&
                            typeof $steps["goToWebSupport"] === "object" &&
                            typeof $steps["goToWebSupport"].then === "function"
                          ) {
                            $steps["goToWebSupport"] =
                              await $steps["goToWebSupport"];
                          }
                        }}
                        type={"_default"}
                      />
                    </React.Fragment>
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageCompass: [
    "pageCompass",
    "appShell",
    "tabLayout",
    "sidenav",
    "pageLayout",
    "topnav",
    "leftSectionNav",
    "separatorHorizontal",
    "pageInfoContainer"
  ],

  appShell: [
    "appShell",
    "tabLayout",
    "sidenav",
    "pageLayout",
    "topnav",
    "leftSectionNav",
    "separatorHorizontal",
    "pageInfoContainer"
  ],

  tabLayout: [
    "tabLayout",
    "sidenav",
    "pageLayout",
    "topnav",
    "leftSectionNav",
    "separatorHorizontal",
    "pageInfoContainer"
  ],

  sidenav: ["sidenav"],
  pageLayout: [
    "pageLayout",
    "topnav",
    "leftSectionNav",
    "separatorHorizontal",
    "pageInfoContainer"
  ],

  topnav: ["topnav", "leftSectionNav"],
  leftSectionNav: ["leftSectionNav"],
  separatorHorizontal: ["separatorHorizontal"],
  pageInfoContainer: ["pageInfoContainer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebCompass__ArgProps,
          internalVariantPropNames: PlasmicWebCompass__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebCompass__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageCompass") {
    func.displayName = "PlasmicWebCompass";
  } else {
    func.displayName = `PlasmicWebCompass.${nodeName}`;
  }
  return func;
}

export const PlasmicWebCompass = Object.assign(
  // Top-level PlasmicWebCompass renders the root element
  makeNodeComponent("pageCompass"),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    tabLayout: makeNodeComponent("tabLayout"),
    sidenav: makeNodeComponent("sidenav"),
    pageLayout: makeNodeComponent("pageLayout"),
    topnav: makeNodeComponent("topnav"),
    leftSectionNav: makeNodeComponent("leftSectionNav"),
    separatorHorizontal: makeNodeComponent("separatorHorizontal"),
    pageInfoContainer: makeNodeComponent("pageInfoContainer"),
    // Metadata about props expected for PlasmicWebCompass
    internalVariantProps: PlasmicWebCompass__VariantProps,
    internalArgProps: PlasmicWebCompass__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP | compass.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicWebCompass;
/* prettier-ignore-end */
